import { call, put } from 'redux-saga/effects';
import serviceLocator, { SSAP_SVC } from '@APIs/common/service-locator';
import { fetchTribesFailure, fetchTribesSuccess } from '@actions/ssap/ssapActionCreators';
import { setTribes } from '@actions/ssap/ssapActionCreators';

export function* tribesSaga() {
    try {
        const ssapService = yield call(serviceLocator, SSAP_SVC);
        const tribes = yield call([ssapService, ssapService.getTribes]);
        if(tribes) {
            yield put(fetchTribesSuccess());
            yield put(setTribes(tribes));
        } else {
            yield put(fetchTribesFailure());
        }
    } catch(e) {
        yield put(fetchTribesFailure());
    }
}